import { render } from "./createrepeatedfield.vue?vue&type=template&id=636e727b&scoped=true"
import script from "./createrepeatedfield.js?vue&type=script&lang=js"
export * from "./createrepeatedfield.js?vue&type=script&lang=js"

import "./createrepeatedfield.vue?vue&type=style&index=0&id=636e727b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636e727b"]])

export default __exports__